/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-dialog-content[_ngcontent-%COMP%]{padding-bottom:10px}mat-dialog-actions[_ngcontent-%COMP%]{justify-content:flex-end}.error[_ngcontent-%COMP%]{color:red;font-weight:bolder}"];
export { styles as styles };
